/** Primary orange gradient used for brand surfaces (header, sidebar, logos). */
export const BRAND_GRADIENT = "linear-gradient(135deg, #f99600, #cc6f00)";

export const BRAND_INITIAL = "J";

export const APP_SHORT_NAME = "JOIP";
